import React from "react";
import { Grid, CircularProgress } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import DialogForm from "@/components/modal/DialogForm";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import FormikNumberInput from "@/components/forms/FormikNumberInput";
import { StyledButton } from "@/components";
import mapOptions from "@/utils/mappers/mapOptions";
import useFetchCommonData from "@/hooks/useFetchCommonData";
import { useAddLopForEmployeeMutation } from "@/api/services/attendanceManagement/muster/Muster";
import { toast } from "@/components/toastify";

const validationSchema = Yup.object({
  empId: Yup.string().required("Please select an employee"),
  noLop: Yup.number()
    .typeError("Must be a number")
    .required("Please enter LOP value")
    .min(0, "Cannot be negative"),
});

const AddLopModal = ({ open, setOpen }) => {
  const { data: employees } = useFetchCommonData("ALLEMPLOYEES");
  const [addLopForEmployee] = useAddLopForEmployeeMutation();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      await addLopForEmployee({ empId: values.empId, noLop: values.noLop }).unwrap();
      toast("success", "LOP added successfully");
      resetForm();
      setOpen(false);
    } catch (error) {
      toast("error", error?.data?.message || "Failed to add LOP");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DialogForm open={open} setOpen={setOpen} title="Add LOP" width="xs">
      <Formik
        initialValues={{ empId: "", noLop: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormikSelectInput
                  name="empId"
                  label="Select Employee"
                  placeholder="Select Employee"
                  options={mapOptions(employees || [])}
                  search={true}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <FormikNumberInput
                  name="noLop"
                  label="LOP Days"
                  placeholder="No Of Days"
                  required
                  // inputProps={{ step: "0.5" }}
                />
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" spacing={1} mt={1}>
              <Grid item>
                <StyledButton label="Cancel" variant="outlined" type="button" onClick={() => setOpen(false)} />
              </Grid>
              <Grid item>
                <StyledButton
                  label={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Submit"}
                  type="submit"
                  variant="contained"
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </DialogForm>
  );
};

export default AddLopModal;
